import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _typeof from "@babel/runtime/helpers/typeof";
import C from "./helpers/bind.js";
var I = Object.prototype.toString,
  h = Object.getPrototypeOf,
  y = /* @__PURE__ */function (e) {
    return function (t) {
      var r = I.call(t);
      return e[r] || (e[r] = r.slice(8, -1).toLowerCase());
    };
  }(/* @__PURE__ */Object.create(null)),
  l = function l(e) {
    return e = e.toLowerCase(), function (t) {
      return y(t) === e;
    };
  },
  g = function g(e) {
    return function (t) {
      return _typeof(t) === e;
    };
  },
  u = Array.isArray,
  p = g("undefined");
function M(e) {
  return e !== null && !p(e) && e.constructor !== null && !p(e.constructor) && c(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
var x = l("ArrayBuffer");
function R(e) {
  var t;
  return (typeof ArrayBuffer === "undefined" ? "undefined" : _typeof(ArrayBuffer)) < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && x(e.buffer), t;
}
var H = g("string"),
  c = g("function"),
  L = g("number"),
  w = function w(e) {
    return e !== null && _typeof(e) == "object";
  },
  k = function k(e) {
    return e === !0 || e === !1;
  },
  m = function m(e) {
    if (y(e) !== "object") return !1;
    var t = h(e);
    return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
  },
  N = l("Date"),
  U = l("File"),
  _ = l("Blob"),
  q = l("FileList"),
  V = function V(e) {
    return w(e) && c(e.pipe);
  },
  z = function z(e) {
    var t;
    return e && (typeof FormData == "function" && e instanceof FormData || c(e.append) && ((t = y(e)) === "formdata" ||
    // detect form-data instance
    t === "object" && c(e.toString) && e.toString() === "[object FormData]"));
  },
  G = l("URLSearchParams"),
  _map = ["ReadableStream", "Request", "Response", "Headers"].map(l),
  _map2 = _slicedToArray(_map, 4),
  J = _map2[0],
  K = _map2[1],
  $ = _map2[2],
  W = _map2[3],
  Q = function Q(e) {
    return e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
  };
function d(e, t) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref$allOwnKeys = _ref.allOwnKeys,
    r = _ref$allOwnKeys === void 0 ? !1 : _ref$allOwnKeys;
  if (e === null || _typeof(e) > "u") return;
  var n, s;
  if (_typeof(e) != "object" && (e = [e]), u(e)) for (n = 0, s = e.length; n < s; n++) t.call(null, e[n], n, e);else {
    var o = r ? Object.getOwnPropertyNames(e) : Object.keys(e),
      i = o.length;
    var f;
    for (n = 0; n < i; n++) f = o[n], t.call(null, e[f], f, e);
  }
}
function P(e, t) {
  t = t.toLowerCase();
  var r = Object.keys(e);
  var n = r.length,
    s;
  for (; n-- > 0;) if (s = r[n], t === s.toLowerCase()) return s;
  return null;
}
var a = (typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis)) < "u" ? globalThis : (typeof self === "undefined" ? "undefined" : _typeof(self)) < "u" ? self : (typeof window === "undefined" ? "undefined" : _typeof(window)) < "u" ? window : global,
  T = function T(e) {
    return !p(e) && e !== a;
  };
function F() {
  var _ref2 = T(this) && this || {},
    e = _ref2.caseless,
    t = {},
    r = function r(n, s) {
      var o = e && P(t, s) || s;
      m(t[o]) && m(n) ? t[o] = F(t[o], n) : m(n) ? t[o] = F({}, n) : u(n) ? t[o] = n.slice() : t[o] = n;
    };
  for (var n = 0, s = arguments.length; n < s; n++) arguments[n] && d(arguments[n], r);
  return t;
}
var X = function X(e, t, r) {
    var _ref3 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
      n = _ref3.allOwnKeys;
    return d(t, function (s, o) {
      r && c(s) ? e[o] = C(s, r) : e[o] = s;
    }, {
      allOwnKeys: n
    }), e;
  },
  Y = function Y(e) {
    return e.charCodeAt(0) === 65279 && (e = e.slice(1)), e;
  },
  Z = function Z(e, t, r, n) {
    e.prototype = Object.create(t.prototype, n), e.prototype.constructor = e, Object.defineProperty(e, "super", {
      value: t.prototype
    }), r && Object.assign(e.prototype, r);
  },
  j = function j(e, t, r, n) {
    var s, o, i;
    var f = {};
    if (t = t || {}, e == null) return t;
    do {
      for (s = Object.getOwnPropertyNames(e), o = s.length; o-- > 0;) i = s[o], (!n || n(i, e, t)) && !f[i] && (t[i] = e[i], f[i] = !0);
      e = r !== !1 && h(e);
    } while (e && (!r || r(e, t)) && e !== Object.prototype);
    return t;
  },
  v = function v(e, t, r) {
    e = String(e), (r === void 0 || r > e.length) && (r = e.length), r -= t.length;
    var n = e.indexOf(t, r);
    return n !== -1 && n === r;
  },
  ee = function ee(e) {
    if (!e) return null;
    if (u(e)) return e;
    var t = e.length;
    if (!L(t)) return null;
    var r = new Array(t);
    for (; t-- > 0;) r[t] = e[t];
    return r;
  },
  te = /* @__PURE__ */function (e) {
    return function (t) {
      return e && t instanceof e;
    };
  }((typeof Uint8Array === "undefined" ? "undefined" : _typeof(Uint8Array)) < "u" && h(Uint8Array)),
  ne = function ne(e, t) {
    var n = (e && e[Symbol.iterator]).call(e);
    var s;
    for (; (s = n.next()) && !s.done;) {
      var o = s.value;
      t.call(e, o[0], o[1]);
    }
  },
  re = function re(e, t) {
    var r;
    var n = [];
    for (; (r = e.exec(t)) !== null;) n.push(r);
    return n;
  },
  se = l("HTMLFormElement"),
  oe = function oe(e) {
    return e.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function (r, n, s) {
      return n.toUpperCase() + s;
    });
  },
  S = function (_ref4) {
    var e = _ref4.hasOwnProperty;
    return function (t, r) {
      return e.call(t, r);
    };
  }(Object.prototype),
  ie = l("RegExp"),
  B = function B(e, t) {
    var r = Object.getOwnPropertyDescriptors(e),
      n = {};
    d(r, function (s, o) {
      var i;
      (i = t(s, o, e)) !== !1 && (n[o] = i || s);
    }), Object.defineProperties(e, n);
  },
  ce = function ce(e) {
    B(e, function (t, r) {
      if (c(e) && ["arguments", "caller", "callee"].indexOf(r) !== -1) return !1;
      var n = e[r];
      if (c(n)) {
        if (t.enumerable = !1, "writable" in t) {
          t.writable = !1;
          return;
        }
        t.set || (t.set = function () {
          throw Error("Can not rewrite read-only method '" + r + "'");
        });
      }
    });
  },
  le = function le(e, t) {
    var r = {},
      n = function n(s) {
        s.forEach(function (o) {
          r[o] = !0;
        });
      };
    return u(e) ? n(e) : n(String(e).split(t)), r;
  },
  fe = function fe() {},
  ae = function ae(e, t) {
    return e != null && Number.isFinite(e = +e) ? e : t;
  },
  A = "abcdefghijklmnopqrstuvwxyz",
  b = "0123456789",
  D = {
    DIGIT: b,
    ALPHA: A,
    ALPHA_DIGIT: A + A.toUpperCase() + b
  },
  ue = function ue() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 16;
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : D.ALPHA_DIGIT;
    var r = "";
    var n = t.length;
    for (; e--;) r += t[Math.random() * n | 0];
    return r;
  };
function pe(e) {
  return !!(e && c(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
var de = function de(e) {
    var t = new Array(10),
      _r = function r(n, s) {
        if (w(n)) {
          if (t.indexOf(n) >= 0) return;
          if (!("toJSON" in n)) {
            t[s] = n;
            var o = u(n) ? [] : {};
            return d(n, function (i, f) {
              var O = _r(i, s + 1);
              !p(O) && (o[f] = O);
            }), t[s] = void 0, o;
          }
        }
        return n;
      };
    return _r(e, 0);
  },
  me = l("AsyncFunction"),
  ye = function ye(e) {
    return e && (w(e) || c(e)) && c(e.then) && c(e.catch);
  },
  E = function (e, t) {
    return e ? setImmediate : t ? function (r, n) {
      return a.addEventListener("message", function (_ref5) {
        var s = _ref5.source,
          o = _ref5.data;
        s === a && o === r && n.length && n.shift()();
      }, !1), function (s) {
        n.push(s), a.postMessage(r, "*");
      };
    }("axios@".concat(Math.random()), []) : function (r) {
      return setTimeout(r);
    };
  }(typeof setImmediate == "function", c(a.postMessage)),
  ge = (typeof queueMicrotask === "undefined" ? "undefined" : _typeof(queueMicrotask)) < "u" ? queueMicrotask.bind(a) : (typeof process === "undefined" ? "undefined" : _typeof(process)) < "u" && process.nextTick || E,
  Ae = {
    isArray: u,
    isArrayBuffer: x,
    isBuffer: M,
    isFormData: z,
    isArrayBufferView: R,
    isString: H,
    isNumber: L,
    isBoolean: k,
    isObject: w,
    isPlainObject: m,
    isReadableStream: J,
    isRequest: K,
    isResponse: $,
    isHeaders: W,
    isUndefined: p,
    isDate: N,
    isFile: U,
    isBlob: _,
    isRegExp: ie,
    isFunction: c,
    isStream: V,
    isURLSearchParams: G,
    isTypedArray: te,
    isFileList: q,
    forEach: d,
    merge: F,
    extend: X,
    trim: Q,
    stripBOM: Y,
    inherits: Z,
    toFlatObject: j,
    kindOf: y,
    kindOfTest: l,
    endsWith: v,
    toArray: ee,
    forEachEntry: ne,
    matchAll: re,
    isHTMLForm: se,
    hasOwnProperty: S,
    hasOwnProp: S,
    // an alias to avoid ESLint no-prototype-builtins detection
    reduceDescriptors: B,
    freezeMethods: ce,
    toObjectSet: le,
    toCamelCase: oe,
    noop: fe,
    toFiniteNumber: ae,
    findKey: P,
    global: a,
    isContextDefined: T,
    ALPHABET: D,
    generateString: ue,
    isSpecCompliantForm: pe,
    toJSONObject: de,
    isAsyncFn: me,
    isThenable: ye,
    setImmediate: E,
    asap: ge
  };
export { Ae as default };
